<template>
  <div>
    <v-card class="pa-5">
      <v-btn
        content
        class="elevation-0 content-none grey--content"
        @click="setEdit"
      >
        <v-icon class="fal fa-arrow-left-long pr-3" size="21"></v-icon>
        <translate>Back</translate>
      </v-btn>
      <v-row no-gutters class="mx-3">
        <v-col cols="12" class="pt-5">
          <AutoForm
            :layout="layout"
            :model="entity"
            @submit="onSubmit"
            singlePhoto
            ref="form"
          />
        </v-col>
        <v-col class="mt-5">
          <v-btn
            color="primary"
            small
            class="content-none font-weight-bold content-h6 py-6 mt-6"
            @click="onSubmit()"
          >
            <v-icon class="fas fa-floppy-disk pr-3"></v-icon>
            <translate>Save</translate>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import YoutubeInput from "@/components/Forms/YoutubeInput";
import FileInput from "@/components/Forms/FileInput";
import TiptapEditor from "@/components/Tiptap/TiptapEditor";
import AutoForm from "@/components/Forms/AutoForm";
import InterviewForm from "@/forms/InterviewForm";
export default {
  name: "EditInterview",
  props: ["course"],
  components: {
    YoutubeInput,
    FileInput,
    TiptapEditor,
    AutoForm,
    InterviewForm,
  },
  created() {
  },
  data() {
    return {
      optionsInterview: [
        { id: 1, name: "Video" },
        { id: 2, name: "Text" },
      ],
      entity: null,
    };
  },
  computed: {
    layout() {
      return InterviewForm.layout(this.entity);
    },
    currentInterview() {
      let interview = JSON.parse(
        JSON.stringify(this.$store.state.interview.currentInterview)
      );
      const photos = [];
      const youtubes = [];
      delete interview.reviewData;
      delete interview.profile;
      delete interview.course;
      delete interview.language;
      delete interview.totalComment;
      delete interview.totalLike;
      delete interview.totalView;
      delete interview.language;
      if (interview.media && interview.media.length !== 0) {
        interview.media.forEach((media) => {
          if (media.type == MEDIA_TYPE_PHOTO) {
            photos.push({
              file: null,
              title: media.description,
              thumb: media.thumbnail,
              id: media.id,
            });
          }
          if (media.type == MEDIA_TYPE_YOUTUBE) {
            youtubes.push({
              id: media.id,
              youtubeId: media.youtubeId,
            });
          }
        });
        delete interview.media;
      }
      interview.course = this.courseDetail.id;
      interview.type = MEDIA_TYPE_INTERVIEW;
      interview.photoFiles = photos;
      interview.youtubes = youtubes;
      return interview;
    },
    courseDetail() {
      return this.$store.state.golfcourse.courseDetail;
    },
  },
  methods: {
    setEdit() {
      this.$emit("setEdit");
    },
    async save() {
      this.data.content = this.$refs.editor.content;
      this.$store.dispatch("updateInterview", this.data);
    },
    inputEditor(value) {
      this.data.content = value;
    },
    resetForm() {
      this.entity = Object.assign({}, InterviewForm.defaultEntity);
    },
    parseFormData(input) {
      let data = { ...input };
      const formData = new FormData();
      console.log(formData);
      console.log("this.currentInterview: ", this.currentInterview);
      if (this.currentInterview && this.currentInterview.photoFiles) {
        this.currentInterview.photoFiles.forEach((photo) => {
          if (!photo.id) return;
          const survivedPhoto = data.photoFiles.find((p) => {
            return p.id && p.id == photo.id;
          });
          console.log("survivedPhoto", survivedPhoto);
          if (survivedPhoto) {
            if (survivedPhoto.title !== photo.title) {
              formData.append(
                "reTitledMedia[]",
                survivedPhoto.id + "reTitledMedia" + survivedPhoto.title
              );
            }
          } else {
            formData.append("removedMedia[]", photo.id);
          }
        });
      }

      if (this.currentInterview && this.currentInterview.youtubes) {
        this.currentInterview.youtubes.forEach((youtube) => {
          if (!youtube.id) return;
          const survivedYoutube = data.youtubes.find((y) => {
            return y.id && y.id == youtube.id;
          });
          if (!survivedYoutube) {
            formData.append("removedMedia[]", youtube.id);
          }
        });
      }

      //parse
      for (let i in data) {
        if (i === "photoFiles") {
          data.photoFiles.forEach((photo) => {
            if (!photo.id) {
              formData.append("photoFiles[]", photo.file);
              formData.append("photoTitles[]", photo.title);
            }
          });
        } else if (i === "youtubes") {
          data.youtubes.forEach((youtube) => {
            if (!youtube.id) {
              formData.append("youtubes[]", youtube);
            }
          });
        } else {
          formData.append(i, data[i]);
        }
      }
      return formData;
    },
    async onSubmit() {
      let vm = this;
      if (vm.$refs["form"].validate()) {
        this.entity.type = MEDIA_TYPE_INTERVIEW;
        this.entity.course = this.course;
        const test = this.parseFormData(this.entity);
        console.log("data: ", test);
        const result = await this.$store.dispatch(
          "interview/updateInterview",
          test
        );
        console.log(result);
        if (result.error) this.$toast.alert(result.error.message);
        else {
          this.$toast.success(this.$gettext(`Update success`));
          await this.$store.dispatch(
            "interview/getInterviewData",
            this.courseDetail.id
          );
          this.setEdit();
        }
      }
    },
  },
  watch: {
    currentInterview: {
      immediate: true,
      handler(value) {
        if (value && value.id) {
          this.resetForm();
          this.entity = JSON.parse(JSON.stringify(value));
        } else {
          this.resetForm();
        }
      },
    },
  },
};
</script>
